export default __webpack_public_path__ + "static/photo-bar-3-63214cf395c4c323d04ff7e33bef99ac.jpg";